import { WSPillProps } from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";

export function getWorkLogPayeeStatusPill(workLog: IWorkLog): WSPillProps {
  if (workLog.invoiceId) {
    return {
      text: "Submitted",
      theme: "success",
      icon: "check-circle"
    };
  }

  return {
    text: "Draft",
    theme: "neutral",
    icon: "draft"
  };
}
